export const SuccessBanner = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 400 108">
    <path fill="#fff" fillOpacity=".01" d="M0 0h400v108H0z" />
    <g>
      <g>
        <path fill="#038164" d="M0 7a7 7 0 0 1 7-7h386a7 7 0 0 1 7 7v101H0V7Z" />
        <path
          fill="#fff"
          fillOpacity=".2"
          d="
            M159.613 7.598c5.045 5.58 12.525 8.371 19.947 7.383 18.787-2.5 32.298 17.73 22.846 34.18a22.96 22.96 0 0 0-.812
            21.334c8.176 17.149-6.784 36.274-25.339 32.321-7.364-1.57-15.018.639-20.469 5.813-13.742
            13.079-36.473 4.708-38.502-14.184-.812-7.499-5.219-14.126-11.829-17.73-16.642-9.068-15.714-33.367 1.565-41.156
            6.843-3.081 11.771-9.36 13.163-16.8C123.604.1 146.914-6.528 159.613 7.6Z
          "
        />
        <g fill="#fff">
          <path fillOpacity=".01" d="M179.5 29h52v52h-52z" />
          <path
            d="
              M205.5 29a26.002 26.002 0 0 0-24.021 16.05A25.999 25.999 0 1 0 231.5 55a26.03 26.03 0 0 0-26-26Zm12.698
              21.798-14.3 14.3a3.242 3.242 0 0 1-2.298.953 3.248 3.248 0 0 1-2.298-.953l-6.5-6.5a3.249 3.249 0 0 1 0-4.596
              3.248 3.248 0 0 1 4.596 0l4.202 4.201 12.002-12.001a3.243 3.243 0 0 1 2.298-.952 3.248 3.248 0 0 1 3.25 3.25
              3.257 3.257 0 0 1-.952 2.298Z
            "
          />
        </g>
      </g>
    </g>
  </svg>

)
